/**
 * SubscriptionCurrencyFormatter interface for formatting currency. Adapted directly from @udemy/ud-data useFormatCurrency.
 */

/**
 * SubscriptionPlan type from api-platform-graphql with deprecated fields removed.
 * productType is also removed so that the decorated subtypes of SubscriptionPlan
 * can each provide the correct productType. Also includes a field indicating that
 * the SubscriptionPlan is loaded.
 */

/**
 * Represents the discount details for a SubscriptionPlanPriceOptionDiscount.
 */

/**
 * Represents the loading state of a subscription plan.
 */

/**
 * Constant that represents the loading state of a subscription plan.
 */
export const SubscriptionPlanIsLoading = {
  isLoading: true
};

/**
 * Represents the subscriber state of a subscription plan ie subscribed vs. unsubscribed.
 */

/**
 * Constant that represents the base state of a user subscribed to a given plan. Needs to be extended with further data
 * to satisfy the full interface.
 */
export const SubscriptionPlanSubscribedState = {
  isSubscriber: true,
  isSubscriberToSpecificPlan: true,
  isLoading: false
};

/**
 * Base type for a SubscriptionPlan tiers under consumer subscription family, such as
 * CONSUMERSUBSCRIPTION, CONSUMERSUBSCRIPTION_VALUE_PLAN.
 */

/**
 * Base types for a SubscriptionPlan with productType = TEAM.
 */

/**
 * Decorated subtypes of SubscriptionPlan with productType = CONSUMERSUBSCRIPTION that provide additional functionality
 * by adding derived properties and utility methods.
 */

/**
 * Decorated subtypes of SubscriptionPlan with productType = CONSUMERSUBSCRIPTION_VALUE_PLAN that provide additional functionality
 * by adding derived properties and utility methods.
 */

/**
 * Decorated subtypes of SubscriptionPlan with productType = TEAM that provide additional functionality
 * by adding derived properties and utility methods.
 */

/**
 * This conditional type is used to determine the correct subtype of a SubscriptionPlan
 * based on the productType field inherited from the Base*SubscriptionPlan base types.
 * It falls back to SubscriptionPlan if the productType is not recognized so that new planProductTypes
 * are supported without decorated subtypes.
 */

/**
 * Defines the union type for a loaded SubscriptionPlan: either a plan or undefined
 */

/**
 * Defines a generic external interface for the subscription plan context object.
 * This tracks the four states of a given user for a given plan:
 * 1. The plan is loading
 * 2. The user is subscribed to the plan
 * 3. The user is not subscribed to the plan and it is available to them
 * 4. The user is not subscribed to the plan and it is not available to them (undefined)
 */
//# sourceMappingURL=subscription-plan.js.map